var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switcher",class:{ 'switcher--disabled': _vm.disabled },on:{"click":function($event){_vm.disabled ? null : _vm.nextValue()},"wheel":function($event){_vm.disabled ? null : _vm.handleWheel($event)}}},[_vm._v("\n  "+_vm._s(_vm.list[_vm.value])+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }